import api from "./instance";

export const getAddresses = () => api.get("/staff/getaddresses");

export const createAddress = (_staffId, payload) =>
  api.post("/staff/create-address", payload);

export const updateAddress = (_staffId, addressId, payload) =>
  api.put("/staff/update-address", { addressId, ...payload });

export const removeAddress = (_staffId, addressId) =>
  api.delete("/staff/remove-address", { data: { addressId } });
